module.exports = __webpack_public_path__ + "img/dsci0024.763d4ef4.jpg";